import { createContext, type PropsWithChildren, useContext } from 'react';

interface EditModeContextType {
  editMode: boolean;
}

const EditModeContext = createContext<EditModeContextType>({
  editMode: false,
});

interface EditModeProviderProps extends PropsWithChildren {
  editMode: boolean;
}

export function EditModeProvider({
  children,
  editMode,
}: EditModeProviderProps) {
  return (
    <EditModeContext.Provider value={{ editMode }}>
      {children}
    </EditModeContext.Provider>
  );
}

export function useEditMode() {
  const context = useContext(EditModeContext);
  if (context === undefined) {
    throw new Error('useEditMode must be used within an EditModeProvider');
  }
  return context;
}
